import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySpreadsheetPage from "@/pages/kakobuy-spreadsheet/page";
import PoradnikZakupowyPage from "@/pages/poradnik-zakupowy/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuySpreadsheetPage />,
  },
  {
    path: "/poradnik-zakupowy",
    element: <PoradnikZakupowyPage />,
  },
  {
    path: "/artykul/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;